<template>
    <div class="mf__width-100">

        <!-- Slider -->
        <div v-for="(secao, index) in secaoVideos" :key="index">
    
            <!-- Título, se necessário -->
            <template v-if="secao.titulo">
                <div>
                    <p class="videos__nome-secao">{{ secao.titulo }}</p>
                </div>
            </template>


            <carousel :items-to-show="1.1" >
                <slide v-for="(video, index) in secao.listaDeVideos" :key="index">
                    
                        <img :src="video.imagem" alt="Avatar" class="video-image" @click="openVideo(video.videoId)"/>
                                     
                </slide>
            </carousel>
        </div>
    </div>
</template>


<script>

import modal from './Modal.vue'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

export default {
    name: "VideosCarousel",
    props: [
        'secaoVideos'
    ],
    components: {
        modal,
        Carousel,
        Slide
    },  
    methods: {
        openVideo(videoId) {
            window.open(`/estatico/youtubePlayer/youtubePlayer.html?videoId=${videoId}`, '_blank');  
        },
    }
}
</script>

<style>

/* Textos */
.videos__nome-secao{
  margin: 5% 0 2% 0;
  font-size: 16px;
  font-weight: 900;
}

/* Override da classe do componente vue-carousel*/
.VueCarousel-slide {
    width: 90%;
    flex-basis: auto;
}

.video-image {
  opacity: 1;
  display: block;
  height: auto;
  width: 98%;
  transition: .5s ease;
  backface-visibility: hidden;
  object-fit: cover;
}


</style>